module.exports = __webpack_public_path__ + "images/70bd521297b649668a2040abaca846a7.jpg";